import { useCallback } from 'react'
import styled from 'styled-components'
import { useQueryClient } from '@tanstack/react-query'

const StyledDrawerPortalContainer = styled.div``

const DrawerPortalContainer = () => {
  const queryClient = useQueryClient()

  const setDrawerContainerRef = useCallback<
    (node?: HTMLDivElement | null | undefined) => void
  >(
    (node) => {
      if (node) {
        queryClient.setQueryData(['drawer-portal-container-node-ref'], node)
        queryClient.invalidateQueries({
          queryKey: ['drawer-portal-container-node-ref'],
          exact: true,
        })
      }
    },
    [queryClient]
  )

  return <StyledDrawerPortalContainer ref={setDrawerContainerRef} />
}

export default DrawerPortalContainer
